import vue from "../../../../main"; // webpack alias

export default function(context) {
  let result = context.$store.dispatch("confirmDialog", {
    content: vue.$t("components.actions.delegation.settleConfirm.content"),
    title: vue.$t("components.actions.delegation.settleConfirm.title")
  });
  result.then(() => {
    //TODO KOMUNIKAT TRWA PRZETWARZANIE
    vue
      .axios({
        url: "delegation/settle",
        data: { id: context.contextItemId },
        method: "POST"
      })
      .then(resp => {
        if (resp.data.status === "OK") {
          context.$store.dispatch("Delegation/loadAllDelegations");
        } else if (resp.data.status === "error") {
          //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
        }
      })
      .catch(() => {
        //TODO obsluga bledow
      });
  });
}
